<template>
  <div>    
    <h6 v-if="idModeRegime!=='hor'" class="bigletterspasing">{{tipp.tippSatz}}</h6>
    <br>

    <div class="row">
      <div class="col s12 m10 l6">
        <table>
          <tbody>
            <tr v-for="(word,index) of tipp.tippWords" v-bind:key="'TW_'+index+'_'+word[0]">
              <td v-if="word[3]==='m'" class="blue-text text-darken-4">{{word[1]}}</td>
              <td v-else-if="word[3]==='f'" class="pink-text">{{word[1]}}</td>
              <td v-else-if="word[3]==='n'" class="orange-text text-darken-2">{{word[1]}}</td>
              <td v-else-if="word[3]==='P'" class="brown-text">{{word[1]}}</td>
              <td v-else-if="word[2].startsWith('Verb')" class="fontbold">{{word[1]}}</td>
              <td v-else>{{word[1]}}</td>

              <td>{{word[0]}}</td>

              <td>{{word[2]}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div v-for="(verb,index) of tipp.tippVerbs" v-bind:key="'TV_'+index+'_'+verb[0]">
      <br />
      <h5 class="fontbold">{{verb[0]}}</h5>

      <div class="row">
        <div class="col s12 m10 l6">
          <table>
            <thead>
              <tr class="grey-text">
                <th></th>
                <th>Präsens</th>
                <th>Präteritum</th>
                <th>Imperativ</th>
              </tr>
            </thead>

            <tbody>
              <tr v-for="(person, index) of persons" v-bind:key="'TP1_'+index+'_'+person">
                <td>{{persons[index]}}</td>
                <td>{{verb[index+1]}}</td>
                <td>{{verb[index+1+6]}}</td>
                <td>{{verb[index+1+6+6]}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="row">
        <div class="col s12 m10 l6">
          <table>
            <thead>
              <tr class="grey-text">
                <th></th>
                <th>Konjunktiv I</th>
                <th>Konjunktiv II</th>
                <th>Partizip</th>
              </tr>
            </thead>

            <tbody>
              <tr v-for="(person, index) of persons" v-bind:key="'TP2_'+index+'_'+person">
                <td>{{persons[index]}}</td>
                <td>{{verb[index+1+6+6+6]}}</td>
                <td>{{verb[index+1+6+6+6+6]}}</td>
                <td>{{verb[index+1+6+6+6+6+6]}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.fontbold {
  font-weight: bold;
}

.bigletterspasing {
  letter-spacing: 0.25em;
}

td {
  padding: 2px 2px;
}
</style>

<script>
export default {
  name: "tipp",
  props: ["idModeRegime"],
  data: () => ({
    persons: ["ich", "du", "er", "wir", "ihr", "sie"]
  }),
  computed: {
    tipp() {
      return this.$store.getters.tipp;
    }
  },
  mounted() {    
  },
  methods: {},
  components: {}
};
</script>
